import billData from '@/services/bill-data';

export default {
  namespaced: true,
  state() {
    return {
      currentBillCycle: {},
      pastBillCycles: [],
      pastBillCycle: [],
      fileResp: '',
      paymentExceptions: {},
      pastBillCycleReturns: [],
      currentBillCycleReturns: [],
    };
  },
  mutations: {
    setCurrentBillCycle(state, payload) {
      state.currentBillCycle = payload;
    },
    setPastBillCycles(state, payload) {
      state.pastBillCycles = payload;
    },
    setPastBillCycle(state, payload) {
      state.pastBillCycle = payload;
    },
    setPastBillCycleReturns(state, payload) {
      state.pastBillCycleReturns = payload;
    },
    setCurrentBillCycleReturns(state, payload) {
      state.currentBillCycleReturns = payload;
    },
    setFile(state, payload) {
      state.fileResp = payload;
    },
    setCycleStatus(state, payload) {
      state.currentBillCycle.isPaused = payload;
    },
    setPaymentExceptions(state, payload) {
      state.paymentExceptions = payload;
    },
  },
  getters: {},
  actions: {
    async fetchCurrentBillCycle({ commit }) {
      const rest = await billData.methods.getCurrentCycleData();
      commit('setCurrentBillCycle', rest);
    },
    async fetchPastBillCycles({ commit }) {
      const rest = await billData.methods.getPastCycleData();
      commit('setPastBillCycles', rest);
    },
    async fetchPastBillCycle({ commit }, params) {
      const rest = await billData.methods.getSinglePastCycleData(params.id);
      commit('setPastBillCycle', rest);
    },
    async fetchPastBillCycleReturns({ commit }, params) {
      const rest = await billData.methods.getPastBillCycleReturns(params.userId, params.id);
      commit('setPastBillCycleReturns', rest);
    },
    async fetchCurrentBillCycleReturns({ commit }, params) {
      const rest = await billData.methods.getCurrentBillCycleReturns(params.userId);
      commit('setCurrentBillCycleReturns', rest);
    },
    async fetchBillngDocument({ commit }, params) {
      // eslint-disable-next-line max-len
      const rest = await billData.methods.getBillngDocument(params.userId, params.billCycle, params.fileName);
      commit('setFile', rest);
    },
    async updateCycleStatus({ commit }, params) {
      const payload = {
        status: params.isPaused === 1 ? 'paused' : '',
        billFrom: params.billFrom,
        billTo: params.billTo,
      };
      // eslint-disable-next-line max-len
      await billData.methods.updateCycleStatus(payload);
      commit('setCycleStatus', payload.status);
    },
    async fetchPaymentExceptions({ commit }) {
      const rest = await billData.methods.getPaymentExceptions();
      commit('setPaymentExceptions', rest);
    },

  },
};
